import { triggerService } from '../services/triggerService';
import { SigningModalTypeValues } from '../../shared/constants/signingModalType';
import { inBusinessExperience } from '../../utils/isBusiness';
import { isBrowser } from '../../utils/isBrowser';
import { businessOpenSignUp, businessOpenSignIn } from './business';
import { type TriggerParams, type ExternalTriggerParams } from './types';

const hasTriggerIdentification = () => {
    if (window.initialData.Identification) {
        return window.initialData.Identification;
    }
    return false;
};

declare global {
    interface Window {
        initialData: {
            Identification?: Record<string, unknown>;
            UserSession: object;
        };
    }
}

const triggerSigningFlow = async ({ modalOptions = {}, biEnrichmentParams = {} }: TriggerParams) => {
    if (!isBrowser()) {
        return;
    }

    return triggerService.trigger(SigningModalTypeValues.identification, modalOptions, biEnrichmentParams);
};

export const triggerSignUp = async (params: ExternalTriggerParams = {}) => {
    const { modalOptions = {}, biEnrichmentParams = {} } = params;

    if (inBusinessExperience() && !hasTriggerIdentification()) {
        await businessOpenSignUp(params);
        return;
    }

    return triggerSigningFlow({
        modalOptions: {
            ...modalOptions,
            mode: 'sign_up',
        },
        biEnrichmentParams,
    });
};

export const triggerSignIn = async (params: ExternalTriggerParams = {}) => {
    const { modalOptions = {}, biEnrichmentParams = {} } = params;

    if (inBusinessExperience() && !hasTriggerIdentification()) {
        await businessOpenSignIn(params);
        return;
    }

    return triggerSigningFlow({
        modalOptions: {
            ...modalOptions,
            mode: 'sign_in',
        },
        biEnrichmentParams,
    });
};
